import { render, staticRenderFns } from "./onlineTraining.vue?vue&type=template&id=bd7856a4&scoped=true"
import script from "./onlineTraining.vue?vue&type=script&lang=js"
export * from "./onlineTraining.vue?vue&type=script&lang=js"
import style0 from "./onlineTraining.vue?vue&type=style&index=0&id=bd7856a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7856a4",
  null
  
)

export default component.exports